// extracted by mini-css-extract-plugin
export default {"brass-grid-delete-button":"DeleteCell_brass-grid-delete-button__neMEL"};